import { CenterLite } from '../center-model/center-lite.model';

export class SMSBasic {

    private active: boolean;
    private centers: Array<CenterLite>;
    private creationDate: number;
    private internalId: string;
    private modificationDate: number;
    private smsArrivalTurn: string;
    private smsName: string;
    private smsPickTurn: string;
    private smsPickAppointment: string;
    private smsPreviousTurn: string;
    private smsSubject: string;

    constructor(active?: boolean, centers?: Array<CenterLite>, creationDate?: number, internalId?: string, modificationDate?: number, smsArrivalTurn?: string, smsName?: string, smsPickTurn?: string, smsPickAppointment?: string, smsPreviousTurn?: string, smsSubject?: string) {
        this.active = active;
        this.centers = centers;
        this.creationDate = creationDate;
        this.internalId = internalId;
        this.modificationDate = modificationDate;
        this.smsArrivalTurn = smsArrivalTurn;
        this.smsName = smsName;
        this.smsPickTurn = smsPickTurn;
        this.smsPickAppointment = smsPickAppointment;
        this.smsPreviousTurn = smsPreviousTurn;
        this.smsSubject = smsSubject;
    }

    public get Active() {
        return this.active;
    }
    public get Centers() {
        return this.centers;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get ModificationDate() {
        return this.modificationDate;
    }
    public get SmsArrivalTurn() {
        return this.smsArrivalTurn;
    }
    public get SmsName() {
        return this.smsName;
    }
    public get SmsPickTurn() {
        return this.smsPickTurn;
    }
    public get SmsPickAppointment() {
        return this.smsPickAppointment;
    }
    public get SmsPreviousTurn() {
        return this.smsPreviousTurn;
    }
    public get SmsSubject() {
        return this.smsSubject;
    }
    public set Active(active) {
        this.active = active;
    }
    public set Centers(centers) {
        this.centers = centers;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set ModificationDate(modificationDate) {
        this.modificationDate = modificationDate;
    }
    public set SmsArrivalTurn(smsArrivalTurn) {
        this.smsArrivalTurn = smsArrivalTurn;
    }
    public set SmsName(smsName) {
        this.smsName = smsName;
    }
    public set SmsPickTurn(smsPickTurn) {
        this.smsPickTurn = smsPickTurn;
    }
    public set SmsPickAppointment(smsPickAppointment) {
        this.smsPickAppointment = smsPickAppointment;
    }
    public set SmsPreviousTurn(smsPreviousTurn) {
        this.smsPreviousTurn = smsPreviousTurn;
    }
    public set SmsSubject(smsSubject) {
        this.smsSubject = smsSubject;
    }
}
